import { AbstractDTO } from "@signature-it/ngx-generic/models";
import { IGetTemporaryTransactionResponse } from "@signature-it/ngx-catalogue/interfaces";
/**
 * Created by shani on 28/11/17.
 */
export class FullJsonDTO extends AbstractDTO implements IGetTemporaryTransactionResponse{

    TransactionNumber: string;
    Transaction: object;
    CreateOrUpdatePOSCustomerErrorCode: number;
    TransactionItemErrorCode: number;
    TransactionItemErrorLine: number;
    CreditCardErrorCode: number;
    CreditCardErrorLine: number;
    CreateShipmentErrorCode: number;
    TemporaryTransactionNumber: string;
    ClubMembership: object;
    CreateCouponErrorCode: number;
    CouponCodeError: string;
    UsePointsErrorCode: string;
    ErrorCode: number;

    constructor(attributes: Object) {
        attributes = attributes ? attributes : {};
        super( attributes );

        this.TransactionNumber =  attributes['TransactionNumber'] || "";
        this.Transaction =  attributes['Transaction'] || null;
        this.CreateOrUpdatePOSCustomerErrorCode =  attributes['CreateOrUpdatePOSCustomerErrorCode'] || 0 ;
        this.TransactionItemErrorCode =  attributes['TransactionItemErrorCode'] || 0;
        this.TransactionItemErrorLine =  attributes['TransactionItemErrorLine'] || 0;
        this.CreditCardErrorCode =  attributes['CreditCardErrorCode'] || 0;
        this.CreditCardErrorLine =  attributes['CreditCardErrorLine'] || 0;
        this.CreateShipmentErrorCode =  attributes['CreateShipmentErrorCode'] || 0;
        this.TemporaryTransactionNumber =  attributes['TemporaryTransactionNumber'] || "";
        this.ClubMembership =  attributes['ClubMembership'] || null;
        this.CreateCouponErrorCode =  attributes['CreateCouponErrorCode'] || 0;
        this.CouponCodeError =  attributes['CouponCodeError'] || "";
        this.UsePointsErrorCode =  attributes['UsePointsErrorCode'] || "";
        this.ErrorCode =  attributes['ErrorCode'] || 0;
    }
}
